<template lang="html">
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="60 80 380 380">
		<path class="st0" d="M370.5,306.5c-19.4,65.7-91.2,112.7-156.9,93.3c-65.7-19.4-100.3-98-80.9-163.7s85.6-93.6,151.2-74.1
			S389.9,240.8,370.5,306.5z"/>
		<g>
			<g>
				<path class="st1" d="M339.2,315.7c0,3.4-2.8,6.2-6.2,6.2H133.9c-3.4,0-6.2-2.8-6.2-6.2v-18.2c0-3.4,2.8-6.2,6.2-6.2H333
					c3.4,0,6.2,2.8,6.2,6.2v16.4V315.7z"/>
				<g>
					<line class="st1" x1="312.8" y1="303.6" x2="319.4" y2="310.2"/>
					<line class="st1" x1="326" y1="303.6" x2="319.4" y2="310.2"/>
				</g>
			</g>
			<g>
				<path class="st1" d="M198.2,368.8c0,3.4-2.8,6.2-6.2,6.2h-58.1c-3.4,0-6.2-2.8-6.2-6.2v-18.2c0-3.4,2.8-6.2,6.2-6.2H192
					c3.4,0,6.2,2.8,6.2,6.2V367V368.8z"/>
			</g>
			<g>
				<path class="st1" d="M256.2,262.6c0,3.4-2.8,6.2-6.2,6.2H133.9c-3.4,0-6.2-2.8-6.2-6.2v-18.2c0-3.4,2.8-6.2,6.2-6.2H250
					c3.4,0,6.2,2.8,6.2,6.2v16.4V262.6z"/>
			</g>
			<g>
				<path class="st1" d="M339.2,209.5c0,3.4-2.8,6.2-6.2,6.2H133.9c-3.4,0-6.2-2.8-6.2-6.2v-18.2c0-3.4,2.8-6.2,6.2-6.2H333
					c3.4,0,6.2,2.8,6.2,6.2v16.4V209.5z"/>
				<g>
					<line class="st1" x1="312.8" y1="197.2" x2="319.4" y2="203.7"/>
					<line class="st1" x1="326" y1="197.2" x2="319.4" y2="203.7"/>
				</g>
			</g>
			<g>
				<path class="st2" d="M299.2,251.1l-6.2,6.3l1.3,8.8c0.1,0.6-0.7,1-0.9,0.7l-8-3.9l-8,3.9c-0.4,0.3-1.1-0.2-0.9-0.7l1.3-8.8
					l-6.2-6.3c-0.5-0.5,0-1,0.4-1.1l8.7-1.4l4.1-7.8c0.2-0.5,0.9-0.5,1.2,0l4.1,7.8l8.8,1.5C299.6,250.2,299.6,250.8,299.2,251.1z"/>
				<path class="st2" d="M332.7,251.1l-6.2,6.3l1.3,8.8c0.1,0.6-0.7,1-0.9,0.7l-8-3.9l-8,3.9c-0.4,0.3-1.1-0.2-0.9-0.7l1.3-8.8
					l-6.2-6.3c-0.5-0.5,0-1,0.4-1.1l8.7-1.4l4.1-7.8c0.2-0.5,0.9-0.5,1.2,0l4.1,7.8l8.8,1.5C333.1,250.2,333.1,250.8,332.7,251.1z"/>
				<path class="st2" d="M366.2,251.1l-6.2,6.3l1.3,8.8c0.1,0.6-0.7,1-0.9,0.7l-8-3.9l-8,3.9c-0.4,0.3-1.1-0.2-0.9-0.7l1.3-8.8
					l-6.2-6.3c-0.5-0.5,0-1,0.4-1.1l8.7-1.4l4.1-7.8c0.2-0.5,0.9-0.5,1.2,0l4.1,7.8l8.8,1.5C366.6,250.2,366.6,250.8,366.2,251.1z"/>
			</g>
			<g>
				<path class="st2" d="M241.2,357.1l-6.2,6.3l1.3,8.8c0.1,0.6-0.7,1-0.9,0.7l-8-3.9l-8,3.9c-0.4,0.3-1.1-0.2-0.9-0.7l1.3-8.8
					l-6.2-6.3c-0.5-0.5,0-1,0.4-1.1l8.7-1.4l4.1-7.8c0.2-0.5,0.9-0.5,1.2,0l4.1,7.8l8.8,1.5C241.6,356.2,241.6,356.8,241.2,357.1z"/>
				<path class="st2" d="M274.7,357.1l-6.2,6.3l1.3,8.8c0.1,0.6-0.7,1-0.9,0.7l-8-3.9l-8,3.9c-0.4,0.3-1.1-0.2-0.9-0.7l1.3-8.8
					l-6.2-6.3c-0.5-0.5,0-1,0.4-1.1l8.7-1.4l4.1-7.8c0.2-0.5,0.9-0.5,1.2,0l4.1,7.8l8.8,1.5C275.1,356.2,275.1,356.8,274.7,357.1z"/>
				<path class="st2" d="M308.2,357.1l-6.2,6.3l1.3,8.8c0.1,0.6-0.7,1-0.9,0.7l-8-3.9l-8,3.9c-0.4,0.3-1.1-0.2-0.9-0.7l1.3-8.8
					l-6.2-6.3c-0.5-0.5,0-1,0.4-1.1l8.7-1.4l4.1-7.8c0.2-0.5,0.9-0.5,1.2,0l4.1,7.8l8.8,1.5C308.6,356.2,308.6,356.8,308.2,357.1z"/>
			</g>
			<g>
				<path class="st2" d="M341.2,357.1l-6.2,6.3l1.3,8.8c0.1,0.6-0.7,1-0.9,0.7l-8-3.9l-8,3.9c-0.4,0.3-1.1-0.2-0.9-0.7l1.3-8.8
					l-6.2-6.3c-0.5-0.5,0-1,0.4-1.1l8.7-1.4l4.1-7.8c0.2-0.5,0.9-0.5,1.2,0l4.1,7.8l8.8,1.5C341.6,356.2,341.6,356.8,341.2,357.1z"/>
				<path class="st2" d="M374.7,357.1l-6.2,6.3l1.3,8.8c0.1,0.6-0.7,1-0.9,0.7l-8-3.9l-8,3.9c-0.4,0.3-1.1-0.2-0.9-0.7l1.3-8.8
					l-6.2-6.3c-0.5-0.5,0-1,0.4-1.1l8.7-1.4l4.1-7.8c0.2-0.5,0.9-0.5,1.2,0l4.1,7.8l8.8,1.5C375.1,356.2,375.1,356.8,374.7,357.1z"/>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>

.st0 {
  fill: #D9DCE2;
}

.st1 {
  fill: #F4EBE1;
  stroke: #FF2834;
  stroke-width: 2.5;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-miterlimit: 10;
}

.st2 {
  fill: #FF2834;
}

</style>



// WEBPACK FOOTER //
// src/components/Animacoes/04-trabalhos-cientificos/avaliacao.vue